import { toast } from "@medusajs/ui"
import { t } from "./i18n"

/**
 * Put text on the clipboard; if the browser refuses (an old in-app browser), say so instead of
 * pretending. `done` is the toast on success, already in the chosen language (callers pass t("…")).
 */
export async function copyText(text: string, done = t("Copied — paste it in the DM.")) {
  try {
    await navigator.clipboard.writeText(text)
    toast.success(done)
  } catch {
    toast.error(t("This browser would not copy. Open it and select the text instead."))
  }
}
